// NOTES
// - so that estimation is always available the permissions check is done on the submit button of the wizard
// - we're always returning the add project button for now

import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { PropTypes } from "prop-types";
import { Button, Divider, Icon } from "semantic-ui-react";

import LinkWithReset from "../utils/LinkWithReset.jsx";

import { OPERATIONS } from "../../constants/operations.js";
import { AT_TYPES } from "../../constants/entity.js";
import { ROUTES } from "../../constants/routing.js";

import { selectOperationAvailability } from "../../state/reducers/endpoints/endpointSelector.js";
import { selectCopy } from "../../state/reducers/locale/copySelector.js";

class ProjectsHeader extends Component {
  static propTypes = {
    createProjectAvailability: PropTypes.object.isRequired,
    copy: PropTypes.func.isRequired
  };

  // -- RENDER -- //

  render() {
    const {
      createProjectAvailability: { permitted, enabled },
      copy
    } = this.props;

    // removed as ALL accounts should be able to see the button for estimate puposes
    // if (permitted !== true) return null;

    return (
      <Fragment>
        <Button
          as={LinkWithReset}
          to={ROUTES.PROJECT_WIZARD}
          floated="right"
          className="add-project-button"
          disabled={!enabled}
        >
          <Icon name="plus circle" />
          {copy("projects.add_new_cta")}
        </Button>
        <Divider clearing />
      </Fragment>
    );
  }
}

const mapStateToProps = state => ({
  createProjectAvailability: selectOperationAvailability(state)(
    AT_TYPES.PROJECT,
    OPERATIONS.CREATE
  ),
  copy: selectCopy(state)
});

export default connect(mapStateToProps, null)(ProjectsHeader);
